
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { EndpointBenchmark } from '@/data/chemicalSafetyData';
import { getConcernLevelColor, getConcernLevelText } from '@/utils/concernLevelUtils';

interface SafetyEndpointCardsProps {
  data: EndpointBenchmark[];
}

export const SafetyEndpointCards = ({ data }: SafetyEndpointCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {data.map((endpoint, index) => (
        <Card key={index}>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm">{endpoint.endpoint}</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-2xl font-bold">{endpoint.yourScore}</span>
                <Badge className={getConcernLevelColor(endpoint.concernLevel)}>
                  {getConcernLevelText(endpoint.concernLevel)}
                </Badge>
              </div>
              
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Industry Avg:</span>
                  <span className="font-medium">{endpoint.industryAvg}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Top Quartile:</span>
                  <span className="font-medium">{endpoint.topQuartile}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">vs Industry:</span>
                  <span className={endpoint.yourScore > endpoint.industryAvg ? 'text-green-600' : 'text-red-600'}>
                    {endpoint.yourScore > endpoint.industryAvg ? '+' : ''}{endpoint.yourScore - endpoint.industryAvg}
                  </span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
